import { getData, getError } from 'conversations-async-data/async-data/operators/getters';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { useCallback } from 'react';
import { useFocusedThreadId } from '../hooks/useFocusedThreadId';
import KnownVisitorContactInfo from './KnownVisitorContactInfo';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UnknownVisitorInfo from './UnknownVisitorInfo';
import { getOpenedContactRecord } from '../constants/Events';
import { useContact } from '../hooks/useContact';
import { getContactLink } from '../../urls/getContactLink';
import { getCanonicalVid, getCompany, getJobTitle } from 'conversations-inbox-lib/contacts/public/operators';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactInformation = ({
  name,
  isKnownContact,
  openAssociateModal,
  shouldDisplayIdentifyBadge
}) => {
  const handleHighlightLinkClick = useCallback(() => {
    trackEvent(getOpenedContactRecord());
  }, []);
  const {
    focusedThreadId
  } = useFocusedThreadId();
  const {
    asyncContact
  } = useContact({
    threadId: focusedThreadId
  });
  const contact = getData(asyncContact);
  const vid = getCanonicalVid(contact);
  const company = getCompany(contact);
  const jobTitle = getJobTitle(contact);
  const contactLink = getContactLink(vid);
  const error = getError(asyncContact); // TODO: Remove cast
  const isObjectNotFound = error && error.message === 'OBJECT_NOT_FOUND';
  if (isObjectNotFound === true && !contact) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.crm-integration.ThreadContactContextualSidebar.noPermission"
    });
  }
  return isKnownContact ? /*#__PURE__*/_jsx(KnownVisitorContactInfo, {
    company: company,
    contactLink: contactLink,
    jobTitle: jobTitle,
    name: name,
    onContactLinkClick: handleHighlightLinkClick,
    shouldDisplayIdentifyBadge: shouldDisplayIdentifyBadge
  }) : /*#__PURE__*/_jsx(UnknownVisitorInfo, {
    openAssociateModal: openAssociateModal
  });
};
ContactInformation.displayName = 'ContactInformation';
export default ContactInformation;